import { IBoltTask } from "@bolt/core";

export enum RichTextEditorsOutputTextTypes {
  PLAIN,
  HTML,
}

export enum TaskCannedGroupingTypes {
  None = 0,
  Discriminator = 1,
  Assignee = 2,
  AssigneeAndDiscriminator = 3,
}

export enum TaskCannedGroupingRepresentativeSelectionTypes {
  MostlyRecentlyCreated = 0,
  LeastRecentlyCreated = 1,
  MostRecentlyUpdated = 2,
  LeastRecentlyUpdated = 3,
  MostRecentlyDue = 4,
  LeastRecentlyDue = 5,
}

export enum TaskCannedGroupingEmptyGroupHandlingTypes {
  /// <summary>
  /// Literally treat each tuple of grouping as a group, so if the grouping contains multple members, and some are null and others are not,
  /// </summary>
  Naive = 0,

  /// <summary>
  /// Excludes a grouping that has a key like (0, 0, ..., 0)
  /// </summary>
  ExcludeGroupingsWithCompletelyEmptyKey = 1,

  /// <summary>
  /// Excludes groupings that has a key like (...,  0, ...)
  /// </summary>
  ExcludeGroupingsWithPartiallyEmptyKey = 2,
}

export enum TaskTimeHorizons {
  PastDue = "Past Due",
  Today = "Today",
  ThisWeek = "This Week",
  ThisMonth = "This Month",
  ThisQuarter = "This Quarter",
  Future = "Future",
  Done = "Done",
}

export interface IBoltKanbanTask extends IBoltTask {
  timeHorizon: TaskTimeHorizons;
}
